import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Book } from '../../types/types';
export type BooksDTO = Book



interface BooksData {
    bookData: BooksDTO[];
}
interface BooksResponse {
    data?: BooksData;
    error?: ApiError;
}

export const GetAllBooks = async (): Promise<BooksResponse> => {
    try {
        const response = await axios.get("/book/all");
            return { data: { bookData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};